import React, { useState, useEffect } from "react";
import styles from "./BusinessFilter.module.css";
import RangeSlider from "../../../UI/RangeSlider/RangeSlider";
import SelectButton from "../../../UI/SelectButton/SelectButton";
import { BusinessCardData } from "../../../CardsComponents/types";
import { calculateDiscountedPrice } from "../../../../utils/discountPriceUtils";

export type FilterSmallState = {
  price_range: [number, number];
  area_range: [number, number];
  floor_range: string[];
};

type FilterProps = {
  onApplyFilter: (filters: FilterSmallState) => void;
  cardData: BusinessCardData[];
  smallFilters: FilterSmallState;
  setSmallFilters: (filters: FilterSmallState) => void;
};

const BusinessFilter: React.FC<FilterProps> = ({
  onApplyFilter,
  cardData,
  smallFilters,
  setSmallFilters,
}) => {
  const [priceLimits, setPriceLimits] = useState<[number, number]>([0, 0]);
  const [areaLimits, setAreaLimits] = useState<[number, number]>([0, 0]);

  // const formatNumber = (num: number): string =>
  //   num.toLocaleString("ru-RU").replace(/,/g, " ");

  const parseFormattedNumber = (value: string): number =>
    parseInt(value.replace(/\s+/g, ""), 10);

  useEffect(() => {
    const prices = cardData.map((card) => {
      const discountedPrice = calculateDiscountedPrice(
        card.pricePerM2 ?? "0",
        card.discountProperty ?? 0,
        card.price ?? "0"
      );
      return parseFormattedNumber(discountedPrice);
    });

    const areas = cardData.map((card) =>
      parseFloat((card.area || '').toString().replace(",", "."))
    );

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);
    const minArea = Math.min(...areas);
    const maxArea = Math.max(...areas);

    setPriceLimits([minPrice, maxPrice]);
    setAreaLimits([minArea, maxArea]);

    setSmallFilters({
      price_range: [minPrice, maxPrice],
      area_range: [minArea, maxArea],
      floor_range: [],
    });
  }, [cardData, setSmallFilters]);

  const updateRange = (key: keyof FilterSmallState, value: [number, number]) => {
    const updatedFilters = {
      ...smallFilters,
      [key]: value,
    };
    setSmallFilters(updatedFilters);
    onApplyFilter(updatedFilters);
  };

  const toggleFloor = (floor: string) => {
    const updatedFilters = {
      ...smallFilters,
      floor_range: smallFilters.floor_range.includes(floor)
        ? smallFilters.floor_range.filter((f) => f !== floor)
        : [...smallFilters.floor_range, floor],
    };
    setSmallFilters(updatedFilters);
    onApplyFilter(updatedFilters);
  };

  return (
    <div className={styles.filter}>
      <div className={styles.filter_select_buttons}>
        <SelectButton
          label="Цоколь"
          isActive={smallFilters.floor_range.includes("Цоколь")}
          onClick={() => toggleFloor("Цоколь")}
          theme="light"
        />
        <SelectButton
          label="1 этаж"
          isActive={smallFilters.floor_range.includes("1 этаж")}
          onClick={() => toggleFloor("1 этаж")}
          theme="light"
        />
        <SelectButton
          label="2 этаж"
          isActive={smallFilters.floor_range.includes("2 этаж")}
          onClick={() => toggleFloor("2 этаж")}
          theme="light"
        />
      </div>
      <div className={styles.range_slider_wrapper}>
        <RangeSlider
          min={priceLimits[0]}
          max={priceLimits[1]}
          value={smallFilters.price_range}
          onChange={(value) => updateRange("price_range", value as [number, number])}
          label="₽"
          theme="light"
        />
      </div>
      <div className={styles.range_slider_wrapper}>
        <RangeSlider
          min={areaLimits[0]}
          max={areaLimits[1]}
          value={smallFilters.area_range}
          onChange={(value) => updateRange("area_range", value as [number, number])}
          label="м²"
          step={0.1}
          decimalPlaces={1}
          theme="light"
        />
      </div>
    </div>
  );
};

export default BusinessFilter;